<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.editEmailContent_header }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <ng-container>
    <form [formGroup]="form">
      <div>
        <div class="editor-container">
          <mat-icon class="section-label">title</mat-icon>
          <p class="grey1">{{data.sysText.emailSubjectLine}}</p>
        </div>
        <div class="tiny-editor">
          <app-email-subject-editor
            [control]="form.controls.subject"
            [placeholderText]="data.sysText.emailSubjectLine"
            [placeHolders]="data.placeholderOptions"
          ></app-email-subject-editor>
        </div>
      </div>
      <span class="spacer"></span>
      <div>
        <div class="editor-container">
          <mat-icon class="section-label">subject</mat-icon>
          <p class="grey1">{{data.sysText.emailBody}}</p>
        </div>
        <div class="tiny-editor">
          <app-email-body-editor
            [control]="form.controls.body"
            [placeholderText]="data.sysText.emailBody"
            [placeHolders]="data.placeholderOptions"
          ></app-email-body-editor>
        </div>
      </div>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

